














import Vue from "vue";
import iwInputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({

    components: {
        iwInputNumber: iwInputNumber
    },
    data: function() {
        return {
            pathInStore: "property.basement.surface",
        };
    },
    computed: {
        floorAreaCellar: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
        hasCellar: function(): boolean {
            return this.$store.getters["FormModule/getValue"]("property.basement.exists");
        }
    },
    methods: {
        updateValue: function(floorAreaCellar: number): void {
            if (!this.hasCellar || (floorAreaCellar == 0 && this.floorAreaCellar != null)) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": floorAreaCellar});
            }
        }
    }
});

